<ng-template #projetoCadastroTemplate>
  <div class="info-page">
    <h3>{{ actionLabel }} Cadastro</h3>
  </div>

  <div class="alert alert-danger" *ngIf="entity?.warns?.length > 0">
    <h5>Inconsistências: </h5>
    <ol>
      <li *ngFor="let warning of entity?.warns">{{ warning?.warn_msg }}</li>
    </ol>
  </div>

  <form [formGroup]="form">
    <h3 class="mt-4 mb-3">I - Identificação</h3>

    <div class="form-group row m-b">
      <div class="col-xxl-8 col-lg-10 col-sm-12">
        <label class="col-sm-12 pb-1">Projeto<sup class="text-danger ms-2">*</sup></label>
        <textarea id="title" class="form-control" formControlName="title" placeholder="Nome sucinto do projeto (MAIÚSCULO)." rows="4" maxlength="300"></textarea>
        <app-field-message [field]="fieldMessageRequired('title')" [erros]="fieldErros('title')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-xxl-8 col-lg-10 col-sm-12">
        <label class="col-sm-12 pb-1">Órgão responsável<sup class="text-danger ms-2">*</sup></label>
        <ng-select id="filter_project_selected" class="ng-select-alternative" [items]="filters?.agencyList" bindLabel="str_nome" bindValue="num_codigo_pk" placeholder="Selecione" formControlName="agency_id"></ng-select>
        <app-field-message [field]="fieldMessageRequired('agency_id')" [erros]="fieldErros('agency_id')"></app-field-message>
      </div>
    </div>

    <div *ngIf="entity?.id">
      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">Situação projeto<sup class="text-danger ms-2">*</sup></label>
          <ng-select id="situation_id" class="ng-select-alternative" [items]="filters?.listSituation" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="situation_id"></ng-select>
          <app-field-message [field]="fieldMessageRequired('situation_id')" [erros]="fieldErros('situation_id')"></app-field-message>
        </div>
      </div>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">Gerente do projeto<sup class="text-danger ms-2">*</sup></label>
          <ng-select id="manager" class="ng-select-alternative" [items]="filters?.personList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="manager"></ng-select>
          <app-field-message [field]="fieldMessageRequired('manager')" [erros]="fieldErros('manager')"></app-field-message>
        </div>
      </div>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">Gerente Adjunto<sup class="text-danger ms-2">*</sup></label>
          <ng-select id="adjunct" class="ng-select-alternative" [items]="filters?.personList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="adjunct"></ng-select>
          <app-field-message [field]="fieldMessageRequired('adjunct')" [erros]="fieldErros('adjunct')"></app-field-message>
        </div>
      </div>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">Proposta validada pelo gestor da Secretaria vinculante</label>
          <ng-select id="plan_aproved" class="ng-select-alternative" [items]="filters?.listPlanAproved" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="plan_aproved"></ng-select>
          <app-field-message [field]="fieldMessageRequired('plan_aproved')" [erros]="fieldErros('plan_aproved')"></app-field-message>
        </div>
      </div>

      <h3 class="mt-4 mb-3">II - Escopo</h3>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">
            <span>Situação-problema<sup class="text-danger ms-2">*</sup></span>
            <i class="pl-1 fa fa-info-circle icon" placement="right" [tooltip]="constant.TOOLTIP_DS_PROBLEM"></i>
          </label>
          <textarea id="ds_problem" class="form-control" formControlName="ds_problem" rows="4" maxlength="2500"></textarea>
          <app-field-message [field]="fieldMessageRequired('ds_problem')" [erros]="fieldErros('ds_problem')"></app-field-message>
        </div>
        <button class="col-xxl-4 col-lg-2 btn btn-success btn-add-item btn-open-modal" type="button" (click)="openProblemModal()">Exibir Árvore</button>
      </div>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">
            <span>Evidências da existência do problema na realidade brasileira e gaúcha</span>
            <i class="pl-1 fa fa-info-circle icon" placement="right" [tooltip]="constant.TOOLTIP_DS_PROBLEM_EVIDENCE"></i>
          </label>
          <textarea id="ds_problem_evidence" class="form-control" formControlName="ds_problem_evidence" rows="4" maxlength="2500"></textarea>
          <app-field-message [field]="fieldMessageRequired('ds_problem_evidence')" [erros]="fieldErros('ds_problem_evidence')"></app-field-message>
        </div>
        <button class="col-xxl-4 col-lg-2 btn btn-success btn-add-item btn-open-modal" type="button" (click)="openLinkModal()">Exibir Links</button>
      </div>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">
            <span>Objeto<sup class="text-danger ms-2">*</sup></span>
            <i class="pl-1 fa fa-info-circle icon" placement="right" [tooltip]="constant.TOOLTIP_DS_OBJECT"></i>
          </label>
          <textarea id="ds_object" class="form-control" formControlName="ds_object" rows="4" maxlength="500"></textarea>
          <app-field-message [field]="fieldMessageRequired('ds_object')" [erros]="fieldErros('ds_object')"></app-field-message>
        </div>
      </div>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">
            <span>Objetivo<sup class="text-danger ms-2">*</sup></span>
            <i class="pl-1 fa fa-info-circle icon" placement="right" [tooltip]="constant.TOOLTIP_DS_OBJECTIVE"></i>
          </label>
          <textarea id="ds_objective" class="form-control" formControlName="ds_objective" rows="4" maxlength="2500"></textarea>
          <app-field-message [field]="fieldMessageRequired('ds_objective')" [erros]="fieldErros('ds_objective')"></app-field-message>
        </div>
      </div>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">
            <span>Contexto e Justificativa<sup class="text-danger ms-2">*</sup></span>
            <i class="pl-1 fa fa-info-circle icon" placement="right" [tooltip]="constant.TOOLTIP_DS_REASON"></i>
          </label>
          <textarea id="ds_reason" class="form-control" formControlName="ds_reason" rows="4" maxlength="3000"></textarea>
          <app-field-message [field]="fieldMessageRequired('ds_reason')" [erros]="fieldErros('ds_reason')"></app-field-message>
        </div>
      </div>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">
            <span>Impactos esperados do projeto para sociedade</span>
            <i class="pl-1 fa fa-info-circle icon" placement="right" [tooltip]="constant.TOOLTIP_DS_IMPACT_SOCIETY"></i>
          </label>
          <textarea id="ds_impact_society" class="form-control" formControlName="ds_impact_society" rows="4" maxlength="3000"></textarea>
          <app-field-message [field]="fieldMessageRequired('ds_impact_society')" [erros]="fieldErros('ds_impact_society')"></app-field-message>
        </div>
      </div>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">
            <span>Descreva práticas de referência para o projeto (benchmarking)</span>
            <i class="pl-1 fa fa-info-circle icon" placement="right" [tooltip]="constant.TOOLTIP_DS_BENCHMARK"></i>
          </label>
          <textarea id="ds_benchmark" class="form-control" formControlName="ds_benchmark" rows="4" maxlength="3000"></textarea>
          <app-field-message [field]="fieldMessageRequired('ds_benchmark')" [erros]="fieldErros('ds_benchmark')"></app-field-message>
        </div>
      </div>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">
            <span>Público-alvo (Beneficiários Diretos)<sup class="text-danger ms-2">*</sup></span>
            <i class="pl-1 fa fa-info-circle icon" placement="right" [tooltip]="constant.TOOLTIP_DS_TARGET"></i>
          </label>
          <textarea id="ds_target" class="form-control" formControlName="ds_target" rows="4" maxlength="1000"></textarea>
          <app-field-message [field]="fieldMessageRequired('ds_target')" [erros]="fieldErros('ds_target')"></app-field-message>
        </div>
      </div>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">
            <span>Número estimado do público-alvo<sup class="text-danger ms-2">*</sup></span>
            <i class="pl-1 fa fa-info-circle icon" placement="right" [tooltip]="constant.TOOLTIP_TOT_DIRECT_BEN"></i>
          </label>
          <input id="tot_direct_ben" class="form-control text-right" formControlName="tot_direct_ben" maxlength="10" (keyup)="formatarMedidaFisica('tot_direct_ben', 0)" />
          <app-field-message [field]="fieldMessageRequired('tot_direct_ben')" [erros]="fieldErros('tot_direct_ben')"></app-field-message>
        </div>
      </div>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">
            <span>Beneficiários indiretos</span>
            <i class="pl-1 fa fa-info-circle icon" placement="right" [tooltip]="constant.TOOLTIP_DS_INDIRECT_BEN"></i>
          </label>
          <textarea id="ds_indirect_ben" class="form-control" formControlName="ds_indirect_ben" rows="4" maxlength="1000"></textarea>
          <app-field-message [field]="fieldMessageRequired('ds_indirect_ben')" [erros]="fieldErros('ds_indirect_ben')"></app-field-message>
        </div>
      </div>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">
            <span>Número estimado dos beneficiários indiretos</span>
            <i class="pl-1 fa fa-info-circle icon" placement="right" [tooltip]="constant.TOOLTIP_TOT_INDIRECT_BEN"></i>
          </label>
          <input id="tot_indirect_ben" class="form-control text-right" formControlName="tot_indirect_ben" maxlength="10" (keyup)="formatarMedidaFisica('tot_indirect_ben', 0)" />
          <app-field-message [field]="fieldMessageRequired('tot_indirect_ben')" [erros]="fieldErros('tot_indirect_ben')"></app-field-message>
        </div>
      </div>

      <h3 class="mt-4 mb-3">III - Territorialização</h3>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">Nível Territorialização da Execução (onde será executado)<sup class="text-danger ms-2">*</sup></label>
          <ng-select id="local_exec_type" class="ng-select-alternative" [items]="filters?.listLocalExec" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="local_exec_type"></ng-select>
          <app-field-message [field]="fieldMessageRequired('local_exec_type')" [erros]="fieldErros('local_exec_type')"></app-field-message>
        </div>
      </div>

      <div *ngIf="form.get('local_exec_type')?.value == '1'">
        <label class="col-sm-12 pb-1">Município</label>
        <div formArrayName="cityexec">
          <div class="form-group row m-b" *ngFor="let item of getFormArray('cityexec').controls; let i = index">
            <div class="col-10 col-md-8 col-xl-4">
              <ng-select class="ng-select-alternative" [items]="filters?.cityList" bindLabel="label" bindValue="id" placeholder="Selecione o Município" [formControlName]="i">
              </ng-select>
            </div>
            <button class="btn btn-danger col-1 btn-remove" type="button" *ngIf="disabledBtn" (click)="removeField(i, 'cityexec')">
              <img src="assets/images/svgs/trash.svg" alt="Remover item" tooltip="Remover item" placement="bottom">
            </button>
          </div>
        </div>
        <button class="btn btn-success btn-add-item mb-4" type="button" *ngIf="disabledBtn" (click)="addField('cityexec')">Novo Município</button>
      </div>

      <div *ngIf="form.get('local_exec_type')?.value == '2'">
        <label class="col-sm-12 pb-1">Corede</label>
        <div formArrayName="coredeexec">
          <div class="form-group row m-b" *ngFor="let item of getFormArray('coredeexec').controls; let i = index">
            <div class="col-10 col-md-8 col-xl-4">
              <ng-select class="ng-select-alternative" [items]="filters?.coredeList" bindLabel="label" bindValue="id" placeholder="Selecione o Corede" [formControlName]="i">
              </ng-select>
            </div>
            <button class="btn btn-danger col-1 btn-remove" type="button" *ngIf="disabledBtn" (click)="removeField(i, 'coredeexec')">
              <img src="assets/images/svgs/trash.svg" alt="Remover item" tooltip="Remover item" placement="bottom">
            </button>
          </div>
        </div>
        <button class="btn btn-success btn-add-item mb-4" type="button" *ngIf="disabledBtn" (click)="addField('coredeexec')">Novo Corede</button>
      </div>

      <div *ngIf="form.get('local_exec_type')?.value == '3'">
        <label class="col-sm-12 pb-1">RF</label>
        <div formArrayName="rfexec">
          <div class="form-group row m-b" *ngFor="let item of getFormArray('rfexec').controls; let i = index">
            <div class="col-10 col-md-8 col-xl-4">
              <ng-select class="ng-select-alternative" [items]="filters?.RFList" bindLabel="label" bindValue="id" placeholder="Selecione o RF" [formControlName]="i">
              </ng-select>
            </div>
            <button class="btn btn-danger col-1 btn-remove" type="button" *ngIf="disabledBtn" (click)="removeField(i, 'rfexec')">
              <img src="assets/images/svgs/trash.svg" alt="Remover item" tooltip="Remover item" placement="bottom">
            </button>
          </div>
        </div>
        <button class="btn btn-success btn-add-item mb-4" type="button" *ngIf="disabledBtn" (click)="addField('rfexec')">Novo RF</button>
      </div>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">Nível Territorialização dos beneficiários (de onde são os beneficiários)<sup class="text-danger ms-2">*</sup></label>
          <ng-select id="local_ben_type" class="ng-select-alternative" [items]="filters?.listLocalBenType" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="local_ben_type"></ng-select>
          <app-field-message [field]="fieldMessageRequired('local_ben_type')" [erros]="fieldErros('local_ben_type')"></app-field-message>
        </div>
      </div>

      <div *ngIf="form.get('local_ben_type')?.value == '1'">
        <label class="col-sm-12 pb-1">Município</label>
        <div formArrayName="cityben">
          <div class="form-group row m-b" *ngFor="let item of getFormArray('cityben').controls; let i = index">
            <div class="col-10 col-md-8 col-xl-4">
              <ng-select class="ng-select-alternative" [items]="filters?.cityList" bindLabel="label" bindValue="id" placeholder="Selecione o Município" [formControlName]="i">
              </ng-select>
            </div>
            <button class="btn btn-danger col-1 btn-remove" type="button" *ngIf="disabledBtn" (click)="removeField(i, 'cityben')">
              <img src="assets/images/svgs/trash.svg" alt="Remover item" tooltip="Remover item" placement="bottom">
            </button>
          </div>
        </div>
        <button class="btn btn-success btn-add-item mb-4" type="button" *ngIf="disabledBtn" (click)="addField('cityben')">Novo Município</button>
      </div>

      <div *ngIf="form.get('local_ben_type')?.value == '2'">
        <label class="col-sm-12 pb-1">Corede</label>
        <div formArrayName="coredeben">
          <div class="form-group row m-b" *ngFor="let item of getFormArray('coredeben').controls; let i = index">
            <div class="col-10 col-md-8 col-xl-4">
              <ng-select class="ng-select-alternative" [items]="filters?.coredeList" bindLabel="label" bindValue="id" placeholder="Selecione o Corede" [formControlName]="i">
              </ng-select>
            </div>
            <button class="btn btn-danger col-1 btn-remove" type="button" *ngIf="disabledBtn" (click)="removeField(i, 'coredeben')">
              <img src="assets/images/svgs/trash.svg" alt="Remover item" tooltip="Remover item" placement="bottom">
            </button>
          </div>
        </div>
        <button class="btn btn-success btn-add-item mb-4" type="button" *ngIf="disabledBtn" (click)="addField('coredeben')">Novo Corede</button>
      </div>

      <div *ngIf="form.get('local_ben_type')?.value == '3'">
        <label class="col-sm-12 pb-1">RF</label>
        <div formArrayName="rfben">
          <div class="form-group row m-b" *ngFor="let item of getFormArray('rfben').controls; let i = index">
            <div class="col-10 col-md-8 col-xl-4">
              <ng-select class="ng-select-alternative" [items]="filters?.RFList" bindLabel="label" bindValue="id" placeholder="Selecione o RF" [formControlName]="i">
              </ng-select>
            </div>
            <button class="btn btn-danger col-1 btn-remove" type="button" *ngIf="disabledBtn" (click)="removeField(i, 'rfben')">
              <img src="assets/images/svgs/trash.svg" alt="Remover item" tooltip="Remover item" placement="bottom">
            </button>
          </div>
        </div>
        <button class="btn btn-success btn-add-item mb-4" type="button" *ngIf="disabledBtn" (click)="addField('rfben')">Novo RF</button>
      </div>

      <h3 class="mt-4 mb-3">IV - Prazo do projeto</h3>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">
            <span>Prazo do Projeto (meses)<sup class="text-danger ms-2">*</sup></span>
            <i class="pl-1 fa fa-info-circle icon" placement="right" [tooltip]="constant.TOOLTIP_EXEC_DURATION"></i>
          </label>
          <input id="exec_duration" class="form-control text-right" formControlName="exec_duration" maxlength="10" (keyup)="formatarMedidaFisica('exec_duration', 0)" />
          <app-field-message [field]="fieldMessageRequired('exec_duration')" [erros]="fieldErros('exec_duration')"></app-field-message>
        </div>
      </div>

      <h3 class="mt-4 mb-3">V - Custo do projeto</h3>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">Custo total estimado (R$)<sup class="text-danger ms-2">*</sup></label>
          <input id="cost_total" class="form-control text-right" formControlName="cost_total" maxlength="10" (keyup)="formatarMedidaFisica('cost_total')" />
          <app-field-message [field]="fieldMessageRequired('cost_total')" [erros]="fieldErros('cost_total')"></app-field-message>
        </div>
      </div>

      <h3 class="mt-4 mb-3">VI - Processo de Captação</h3>

      <div class="form-group row m-b">
        <div class="col-xxl-8 col-lg-10 col-sm-12">
          <label class="col-sm-12 pb-1">Processo vinculado</label>
          <ng-select id="process_id" class="ng-select-alternative" [items]="entity?.processList" bindLabel="title" bindValue="id" placeholder="Selecione" formControlName="process_id"></ng-select>
          <app-field-message [field]="fieldMessageRequired('process_id')" [erros]="fieldErros('process_id')"></app-field-message>
        </div>
      </div>

      <div *ngIf="entity?.questions?.length">
        <div formArrayName="questions">
          <div *ngFor="let item of entity?.questions let i = index" [formGroupName]="0">

            <h3 *ngIf="shouldShowHeader(item.tab_group_name, i)" class="mt-4 mb-3">{{item?.tab_group_name}}</h3>

            <div class="form-group row m-b" *ngIf="item?.type_id == filters?.ppQuestion['TYPE_TEXTO']" [formGroupName]="item?.question_id">
              <div class="col-xxl-8 col-lg-10 col-sm-12">
                <label class="col-sm-12 pb-1">
                  <span *ngIf="!item?.ref_link; else itemLink">{{ item?.title }}<sup class="text-danger ms-2">*</sup></span>
                  <ng-template #itemLink>
                    <a [href]="item?.ref_link" target="_blank" rel="noopener noreferrer">{{ item?.title }}</a>
                  </ng-template>
                  <i class="pl-1 fa fa-info-circle icon" placement="right" *ngIf="item?.tooltip" [tooltip]="item?.tooltip"></i>
                </label>
                <textarea class="form-control" formControlName="ds_value" rows="4" [maxlength]="item?.max_length"></textarea>
                <app-field-message [field]="fieldMessageRequireds(item?.question_id)" [erros]="fieldErrosFormArray(item?.question_id)"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b" *ngIf="item?.type_id == filters?.ppQuestion['TYPE_NUMERICO']" [formGroupName]="item?.question_id">
              <div class="col-xxl-8 col-lg-10 col-sm-12">
                <label class="col-sm-12 pb-1">
                  <span *ngIf="!item?.ref_link; else itemLink">{{ item?.title }}<sup class="text-danger ms-2">*</sup></span>
                  <ng-template #itemLink>
                    <a [href]="item?.ref_link" target="_blank" rel="noopener noreferrer">{{ item?.title }}</a>
                  </ng-template>
                  <i class="pl-1 fa fa-info-circle icon" placement="right" *ngIf="item?.tooltip" [tooltip]="item?.tooltip"></i>
                </label>
                <input id="filter_cost_total1" class="form-control text-right" formControlName="ds_value" (keyup)="formatarMedidaFisica2(item?.question_id, item?.dec_places !== null ? item?.dec_places : 4)">
                <app-field-message [field]="fieldMessageRequireds(item?.question_id)" [erros]="fieldErrosFormArray(item?.question_id)"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b" *ngIf="item?.type_id == filters?.ppQuestion['TYPE_DATA']" [formGroupName]="item?.question_id">
              <div class="col-xxl-8 col-lg-10 col-sm-12">
                <label class="col-sm-12 pb-1">
                  <span *ngIf="!item?.ref_link; else itemLink">{{ item?.title }}<sup class="text-danger ms-2">*</sup></span>
                  <ng-template #itemLink>
                    <a [href]="item?.ref_link" target="_blank" rel="noopener noreferrer">{{ item?.title }}</a>
                  </ng-template>
                  <i class="pl-1 fa fa-info-circle icon" placement="right" *ngIf="item?.tooltip" [tooltip]="item?.tooltip"></i>
                </label>
                <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="ds_value" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa" (keyup)="clearInput($event)">
                <app-field-message [field]="fieldMessageRequireds(item?.question_id)" [erros]="fieldErrosFormArray(item?.question_id)"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b" *ngIf="item?.type_id == filters?.ppQuestion['TYPE_COMBO']" [formGroupName]="item?.question_id">
              <div class="col-xxl-8 col-lg-10 col-sm-12">
                <label class="col-sm-12 pb-1">
                  <span *ngIf="!item?.ref_link; else itemLink">{{ item?.title }}<sup class="text-danger ms-2">*</sup></span>
                  <ng-template #itemLink>
                    <a [href]="item?.ref_link" target="_blank" rel="noopener noreferrer">{{ item?.title }}</a>
                  </ng-template>
                  <i class="pl-1 fa fa-info-circle icon" placement="right" *ngIf="item?.tooltip" [tooltip]="item?.tooltip"></i>
                </label>
                <ng-select id="filter_corede_ben" class="ng-select-alternative" [items]="item?.questionList" [multiple]="true" bindLabel="ds_value" bindValue="ds_value" placeholder="Todos" formControlName="ds_value">
                </ng-select>
                <app-field-message [field]="fieldMessageRequireds(item?.question_id)" [erros]="fieldErrosFormArray(item?.question_id)"></app-field-message>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-danger m-r-xxl" *ngIf="entity?.id && entity?.can_delete" (click)="confirmExcluir()" type="button">Excluir</button>
        <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
        <button class="btn btn-white m-r-xs" *ngIf="entity?.id" type="button" (click)="imprimir()">Imprimir</button>
        <button class="btn btn-white m-r-xs" *ngIf="entity?.id && entity?.can_clone" type="button" (click)="openCloneModal()">Clonar</button>
        <button class="btn btn-primary" *ngIf="!entity?.id && filters?.can_create" (click)="salvar()">Salvar</button>
        <button class="btn btn-primary" *ngIf="entity?.id && entity?.can_save" (click)="update()">Salvar</button>
      </div>
    </div>

    <ng-template #modalProblem>
      <div class="modal-header">
        <h4 class="modal-title pull-left">Árvore de problemas</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeProblemModal()">
          <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
      </div>
      <div class="modal-body table-form">
        <div class="form-group row m-b">
          <div class="col-xxl-8 col-lg-10 col-sm-12">
            <label class="col-sm-12 pb-1">Consequências do problema</label>
            <textarea id="ds_problem_result" class="form-control" formControlName="ds_problem_result" rows="4" maxlength="2500"></textarea>
          </div>
        </div>
        <div class="form-group row m-b">
          <div class="col-xxl-8 col-lg-10 col-sm-12">
            <label class="col-sm-12 pb-1">
              <span>Situação-problema</span>
              <i class="pl-1 fa fa-info-circle icon" placement="right" [tooltip]="constant.TOOLTIP_DS_PROBLEM_MODAL"></i>
            </label>
            <textarea id="ds_problem2" class="form-control" formControlName="ds_problem2" rows="4" maxlength="2500"></textarea>
            <app-field-message [field]="fieldMessageRequired('ds_problem2')" [erros]="fieldErros('ds_problem2')"></app-field-message>
          </div>
        </div>
        <div class="form-group row m-b">
          <div class="col-xxl-8 col-lg-10 col-sm-12">
            <label class="col-sm-12 pb-1">Causas do problema</label>
            <textarea id="ds_problem_cause" class="form-control" formControlName="ds_problem_cause" rows="4" maxlength="2500"></textarea>
          </div>
        </div>
        <div class="hr-line-dashed"></div>
        <div class="form-group row d-flex justify-content-end">
          <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
            <button class="btn btn-white m-r-xs" type="button" (click)="closeProblemModal()">Fechar</button>
            <button class="btn btn-primary" type="button" (click)="saveProblemModal()">Salvar</button>
          </div>
        </div>
      </div>
    </ng-template>
  </form>

  <app-historico-atualizacoes-list *ngIf="entity?.id" [audit]="audit"></app-historico-atualizacoes-list>

  <ng-template #modalClone>
    <div class="modal-header">
      <h4 class="modal-title pull-left">Clonar projeto</h4>
      <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeCloneModal()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </button>
    </div>
    <div class="modal-body table-form">
      <div class="form-group row">
        <div class="col-sm-12 m-b">
          <label class="col-sm-12 pb-1">Novo Nome</label>
          <input class="form-control" [(ngModel)]="clone_title" maxlength="300">
        </div>
      </div>
      <div class="hr-line-dashed"></div>
      <div class="form-group row d-flex justify-content-end">
        <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
          <button class="btn btn-white m-r-xs" type="button" (click)="closeCloneModal()">Fechar</button>
          <button class="btn btn-primary" type="button" [disabled]="!clone_title" (click)="clonar()">Clonar</button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #modalLink>
    <div class="modal-header">
      <h4 class="modal-title pull-left">Links</h4>
      <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeLinkModal()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </button>
    </div>
    <div class="modal-body table-form">
      <ul class="links">
        <li *ngFor="let link of entity?.linkList">
          <a [href]="link?.url" target="_blank">
            {{link?.name}}
            <i class="pl-1 fa fa-info-circle icon" placement="right" *ngIf="link?.tooltip" [tooltip]="link?.tooltip"></i>
          </a>
        </li>
      </ul>
      <div class="hr-line-dashed"></div>
      <div class="form-group row d-flex justify-content-end">
        <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
          <button class="btn btn-white m-r-xs" type="button" (click)="closeLinkModal()">Fechar</button>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>

<div *ngIf="entity?.id, else novoProjeto">
  <ng-container *ngTemplateOutlet="projetoCadastroTemplate"></ng-container>
</div>

<ng-template #novoProjeto>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-4">
      <h2>Projeto</h2>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content box-content">
            <ng-container *ngTemplateOutlet="projetoCadastroTemplate"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-loading [loader]="isLoading"></app-loading>